import _ from 'lodash';
import { getAxiosClient } from '~src/api';
import { onErrorShowMessage } from '~src/errors';
import { trackEvent } from '~src/tracking';
import { startRemovebgLoader } from './startRemovebgLoader';
import { stopAiLoader } from '~core/aiLoader';
// import { showRemoveBgDialog } from './showRemoveBgDialog'; // Deprecated - now applying directly
import { applySelectedRemoveBg } from './applySelectedRemoveBg';
import { prepareImageForEditing } from '~core/image';
import { isPlaceholderEditing } from '~core/magicFrame';
import { checkAiCreditsBeforeUse } from '~core/aiCredits';

export const removeBg = async () => {
  const startTime = performance.now();
  const trackingEventName = 'AI RemoveBG';

  // Check credits before starting the operation
  const hasCredits = await checkAiCreditsBeforeUse({
    featureName: 'RemoveBG',
    requiredCredits: 1,
  });

  if (!hasCredits) {
    return;
  }

  startRemovebgLoader({ isBlurBg: false });

  let selection = window.canvas.getActiveObject();
  if (selection.type === 'MagicFrame') {
    selection = selection.editingImg;
  }

  if (isPlaceholderEditing(selection)) {
    return;
  }

  const imageUrl = await prepareImageForEditing(selection, false);
  if (!imageUrl) {
    console.error('No image URL found in current selection', selection);
    return;
  }

  const httpClient = await getAxiosClient();

  const data = {
    image_url: imageUrl,
  };

  let response;

  try {
    response = await httpClient.post(
      `${process.env.REMOVEBG_API_URL}/removebg`,
      data
    );
  } catch (err) {
    trackEvent(trackingEventName, {
      success: false,
      error_status: _.get(err, 'response.status'),
      time_taken: parseInt(performance.now() - startTime, 10),
    });
    stopAiLoader();
    return onErrorShowMessage();
  }

  // Update cached credits after successful operation

  // Deprecated dialog flow - now applying directly to canvas
  // showRemoveBgDialog(imageUrl, response.data.image, startTime, loaderInstance);

  // Apply the result directly
  await applySelectedRemoveBg(imageUrl, response.data.image, startTime);
};
